<template>
  <div>
    <h1
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
    >
      {{ $t("ecosystem.certificate") }}
    </h1>
    <div class="table-responsive bg-white shadow-md rounded my-6 mt-0">
          <table class="text-left w-full border-collapse">
            <thead>
              <tr>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("declarations.date_of_the_declaration") }}
                </th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("declarations.status") }}
                </th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
                  {{ $t("declarations.declaration_type") }}
                </th>
                <th class="py-4 px-22 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light text-center">
                  {{ $t("demandes.action") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="hover:bg-grey-lighter" v-for="(currDec, index) in declarations" :key="index">
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{new Date(currDec.created_at) | dateFormat('DD/MM/YYYY')}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{ $t('investor.declaration_accepted')}}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-grey-dark">
                  <span>{{ $t("ecosystem.investor_declaration") }}</span>
                </td>
                <td class="py-4 px-6 border-b border-grey-light text-blue text-right">
                  <sp-button v-if="currDec.code_investor" class="text-grey text-sm font-medium"
                  theme="outline-blue"
                  space="small"
                  type="submit"
                  name="next"
                  @click="downloadDeclaration(currDec.code_investor)"
                  >
                    {{ $t('investor.download') }}
                  </sp-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    <!-- <div v-if="declaration && declaration.status && ['0', '2'].includes(declaration.status)">
      <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
        <p class="text-2sm text-bold text-white">{{ $t("status.declarationNotSubmitMessage")}}</p>
      </div>
    </div>
    <div v-if="declaration && declaration.status && declaration.status == '1'">
      <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
        <p class="text-2sm text-bold text-white">{{ $t('status.declarationSubmit')}}</p>
      </div>
    </div>
    <div v-if="declaration && declaration.status && declaration.status == '3'">
      <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-success" style="background: linear-gradient(313.72deg, #AED880 0%, #76B049 100%)">
        <i class="sp-icon-check-circle-1-copy text-green-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
        <p class="text-2sm text-bold text-white">{{ $t('investor.declaration_accepted')}}</p>
      </div>
      <div v-if="declaration.code" class="text-grey text-sm font-medium">
        <sp-button
          theme="outline-blue"
          space="small"
          type="submit"
          name="next"
          @click="downloadDeclaration(declaration.code)"
        >{{ $t("investor.download")}}</sp-button>
      </div>
    </div>
    <div v-if="declaration && declaration.status && declaration.status == '4'">
      <div class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
        <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
        <p class="text-2sm text-bold text-white">{{ $t("investor.declaration_refused")}}</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  GET_INVESTOR_DECLARATION,
  DOWNLOAD_INVESTOR_DECLARATION
} from "@/store/actions.type";
import Button from "../../components/spKit/Button.vue";
import { SET_ECOSYSTEM_MENU_ACTIVE } from "@/store/mutations.type";
import { mapGetters } from "vuex";
import axios from 'axios';

export default {
  name: 'Certificate',
  components: {
    "sp-button": Button
  },
  data() {
    return {
      declaration: null,
      declarations: null
    };
  },
  mounted(){
    this.$Progress.start();
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    this.$store
      .dispatch(GET_INVESTOR_DECLARATION, this.$route.params.ecoAppId)
      .then(data => {
        this.declaration = data.data.declaration;
        this.declarations = data.data.declarations;
      });
    this.$Progress.finish();
  },
  methods: {
    base64ToArrayBuffer(data) {
      var binaryString = window.atob(data);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    downloadDeclaration(code) {
      this.$store.dispatch(DOWNLOAD_INVESTOR_DECLARATION, code)
        .then((response) => {
          // Decrypt base64 file to array buffer
          var arrBuffer = this.base64ToArrayBuffer(response);

          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([arrBuffer], { type: "application/pdf" });

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
          }

          // For other browsers: 
          // Create a link pointing to the ObjectURL containing the blob.
          var data = window.URL.createObjectURL(newBlob);

          var link = document.createElement('a');
          document.body.appendChild(link); //required in FF, optional for Chrome
          link.href = data;
          link.download = "file.pdf";
          link.click();
          window.URL.revokeObjectURL(data);
          link.remove();
      });
    }
  },
  computed: {
    ...mapGetters([
      "ecosystemApp",
      "currentUser"
    ])
  }
};
</script>

<style></style>
